import React, { type Dispatch, type FunctionComponent, type SetStateAction } from 'react'
import { getValueForKey, isObject } from '../../../../../../lib/objectUtils'
import { getReadableValue } from '../../../common/charity.utils'

type Props = {
  data: object
  keyMap: object
  level?: number
  prefix: string
  keysToIgnore?: string[]
  checklistOptions?: {
    CheckListElement: FunctionComponent<{
      item: string
      keyMap: object
      selectedItems: string[]
      setSelectedItems: Dispatch<SetStateAction<string[]>>
    }>
    selectedItems: string[]
    setSelectedItems: Dispatch<SetStateAction<string[]>>
  }
}

export const RecursiveList: FunctionComponent<Props> = ({
  prefix,
  data,
  level = 1,
  keyMap,
  keysToIgnore = [],
  checklistOptions
}) => {
  return (
    <fieldset className="grid gap-sm">
      <legend className={`${level === 1 ? 'text-lg' : 'text-md mt-md'} capitalize mb-sm`}>
        {getValueForKey(keyMap, prefix)}
      </legend>

      {Object.keys(data).map((key, i) => {
        if (keysToIgnore.includes(key)) {
          return null
        }

        const value = data[key as keyof typeof data]

        if (isObject(value)) {
          return (
            <RecursiveList
              keyMap={keyMap}
              keysToIgnore={keysToIgnore}
              level={level + 1}
              prefix={`${prefix}.${key}`}
              data={value}
              key={`rec-${i}`}
              {...(checklistOptions ? { checklistOptions } : {})}
            />
          )
        }

        return checklistOptions ? (
          <checklistOptions.CheckListElement
            key={`det-${i}`}
            keyMap={keyMap}
            item={`${prefix}.${key}`}
            selectedItems={checklistOptions.selectedItems}
            setSelectedItems={checklistOptions.setSelectedItems}
          />
        ) : (
          <div key={`det-${i}`} className="grid gap-md grid-cols-3 p-xs even:bg-grey-light">
            <div>{getValueForKey(keyMap, `${prefix}.${key}`)}</div>
            <div className="col-span-2">{getReadableValue(key, value)}</div>
          </div>
        )
      })}
    </fieldset>
  )
}
